export default __webpack_public_path__ + "static/t-500-7d8dac23d24f6961f57ea5eb137cf5e7.png";